var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_10821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4887 9.99998L19.6917 1.79695C20.1028 1.38586 20.1028 0.719374 19.6917 0.30832C19.2806 -0.102773 18.6141 -0.102773 18.2031 0.30832L9.99998 8.51135L1.79695 0.30832C1.38586 -0.102773 0.719374 -0.102773 0.30832 0.30832C-0.102734 0.719413 -0.102773 1.3859 0.30832 1.79695L8.51135 9.99998L0.30832 18.203C-0.102773 18.6141 -0.102773 19.2806 0.30832 19.6916C0.719413 20.1027 1.3859 20.1027 1.79695 19.6916L9.99998 11.4886L18.203 19.6916C18.6141 20.1027 19.2806 20.1027 19.6916 19.6916C20.1027 19.2805 20.1027 18.6141 19.6916 18.203L11.4887 9.99998Z",
    fill: "#C60F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_10821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCross);
export default __webpack_public_path__ + "static/media/plan_cross.660b59eb139c24c2cf97a6fd5388dd7d.svg";
export { ForwardRef as ReactComponent };